export const projects = [
  {
    id: 1,
    title: "Bosch Portal",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Enterprise CRM & Operations",
    desc: "A multi-module enterprise CRM and dealer operations platform built for Bosch to manage customer relationships, field sales visits, dealer performance analytics, and warranty lifecycles.",
    highlights: [
      "Built dedicated CRM sub-systems (Battery CRM, Test Devices, Tempo) with customer hierarchies, visit tracking, and regional sales heatmaps.",
      "Engineered warranty & reclamation workflows, dealer turnover tracking dashboards, and campaign engines with DevExtreme grids and Chart.js."
    ],
    tech: ["React.js", "TypeScript", "Vite", "TanStack Query", "Material UI", "DevExtreme", "MSAL (Azure AD)", "Chart.js"],
    link: "#"
  },
  {
    id: 2,
    title: "E-Mutabakat",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "FinTech & Digital Reconciliation",
    desc: "An enterprise financial reconciliation (e-mutabakat) web platform built to automate account extract comparison, BA/BS reconciliation, and secure digital consensus workflows.",
    highlights: [
      "Developed high-volume Excel account extract comparison engines with custom balance matching algorithms and interactive DevExtreme grids.",
      "Implemented secure multi-party consensus workflows featuring OTP SMS verification, Google reCAPTCHA, and digital signature pads."
    ],
    tech: ["React.js", "Redux Toolkit", "Material UI", "Tailwind CSS", "DevExtreme", "react-hook-form", "Yup", "XLSX"],
    link: "#"
  },
  {
    id: 3,
    title: "BSH Control Tower",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Enterprise Dashboard & Analytics",
    desc: "A large-scale enterprise React application for real-time monitoring and operational control of business processes. Built high-performance dashboards to handle massive amounts of real-time data.",
    highlights: [
      "Developed data-intensive dashboards and advanced data grids with complex filtering, sorting, exporting, and rendering.",
      "Implemented real-time data updates and interactive visualizations to improve operational visibility and decision-making."
    ],
    tech: ["React.js", "JavaScript (ES6)", "DevExtreme", "DevExpress React Grid", "CoreUI", "SignalR"],
    link: "#"
  },
  {
    id: 4,
    title: "Akbank OKR",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Performance Management (HR-Tech)",
    desc: "An enterprise-level performance management application integrated with the Wokr platform for Akbank. Developed evaluation workflows and automated data synchronization.",
    highlights: [
      "Developed quota-based employee evaluation workflows (A–E scale) and calibration processes.",
      "Built automated data transfers and state handling for thousands of employees."
    ],
    tech: ["React.js", "TypeScript", "Ant Design", "Tailwind CSS", "TanStack Query", "Context API"],
    link: "#"
  },
  {
    id: 5,
    title: "Polifarma Masraf",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Expense Management & FinTech",
    desc: "A multi-tenant enterprise application for digital expense management and approval workflows, utilizing dynamic forms and validation systems.",
    highlights: [
      "Implemented dynamic, multi-step expense forms with complex validation logic.",
      "Created fluid approval flows and status tracking dashboards for financial controllers."
    ],
    tech: ["React.js", "TypeScript", "Material UI", "Tailwind CSS", "TanStack Query", "react-hook-form", "Yup", "DevExtreme"],
    link: "#"
  },
  {
    id: 6,
    title: "BTS ESG",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Compliance & ESG",
    desc: "An ESG-focused web application for environmental, social, and governance compliance, featuring custom form builders, responses tracking, and multi-language support.",
    highlights: [
      "Implemented multilingual support using i18next and localized form schemas.",
      "Built complex form response tracking systems for compliance auditing."
    ],
    tech: ["React.js", "TypeScript", "Material UI", "Tailwind CSS", "Redux Toolkit", "DevExtreme", "i18next", "react-hook-form"],
    link: "#"
  },
  {
    id: 7,
    title: "BTS Talent Finance",
    company: "NTT DATA Business Solutions",
    role: "Frontend Developer",
    category: "Financial Analytics",
    desc: "A complex loan calculation and financial analysis application designed for enterprise talent accounting, focused on rigorous form validation and state management.",
    highlights: [
      "Engineered secure and precise loan calculation forms and currency conversion workflows.",
      "Optimized application bundle size and state management with Redux Toolkit and Webpack."
    ],
    tech: ["React.js", "TypeScript", "Material UI", "Tailwind CSS", "Redux Toolkit", "Webpack"],
    link: "#"
  }
];

export const personalProjects = [
  {
    id: 8,
    title: "Blog App",
    category: "Personal Project",
    desc: "A blogging dashboard application integrated with Firebase Realtime Database to compose, publish, and manage posts.",
    tech: ["React.js", "Firebase", "CSS3"],
    link: "https://s-blog-app.vercel.app/"
  },
  {
    id: 9,
    title: "Movie Database App",
    category: "Personal Project",
    desc: "A movie browsing portal that queries real-time lists, film posters, ratings, and classifications utilizing the TMDB API.",
    tech: ["React.js", "REST API", "CSS3"],
    link: "https://movie-app-sezginakgul.vercel.app/"
  },
  {
    id: 10,
    title: "Recipe Search App",
    category: "Personal Project",
    desc: "An interactive recipe finder that details ingredient lists and dietary analytics powered by the Edamam API.",
    tech: ["React.js", "Edamam API", "CSS3"],
    link: "https://recipe-app-sezginakgul.vercel.app/"
  }
];
